import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Select from "react-select";

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';
import WAFRestrictionBanner from './WAFRestrictionBanner';

import './Ship.css'
import { useTranslation } from "react-i18next";
import { fetchOrderedCards, isPersonalInfoRestricted } from '../../../utils/apiClient';

const Ordered = () => {
  const { t } = useTranslation();

  const [holdList, setHoldList] = useState([])
  const [isRestricted, setIsRestricted] = useState(false)
  const [restrictionMeta, setRestrictionMeta] = useState(null)

  useEffect(() => {

    const api = async () => {
      try {
        const response = await fetchOrderedCards();
        const responseData = await response.json();
        
        // 新しいレスポンス形式に対応
        if (responseData.data) {
          setHoldList(responseData.data);
          setIsRestricted(responseData.meta?.personal_info_restricted || false);
          setRestrictionMeta(responseData.meta || null);
          
          if (responseData.meta?.personal_info_restricted) {
            console.log('個人情報が制限されています（注文済みカード）:', responseData.meta?.message);
          }
        } else {
          setHoldList(responseData);
          setIsRestricted(false);
          setRestrictionMeta(null);
        }
      } catch (error) {
        console.error('注文済みカードの取得に失敗しました:', error);
      }
    }

    const timer = setTimeout(() => {
      api();
    }, 500)
  
  }, [])



  
  const CreateShipmentList = () => {
    return holdList.map((ship) => {
      return (
        <>
          <tr>
            <td>{ship.name}</td>
            <td>{ship.rank}</td>
            <td>{ship.count}</td>
          </tr>
        </> 
      )
    })
  }


  return (
    <>
      <Header />
      <SideMenu />
      <div className="ship">
        <div className="ship-title">{t('ordered.title')}</div>
        <div className='clearfix'></div>
        
        {isRestricted && <WAFRestrictionBanner meta={restrictionMeta} />}
        
        <div className="ship-content">
          <div className="ship-content-table">
            <table className="ship-content-table">
              <thead>
                <tr>
                  <th>{t('ordered.name')}</th>
                  <th>{t('ordered.rank')}</th>
                  <th>{t('ordered.value')}</th>
                </tr>
              </thead>
              <tbody>
                <CreateShipmentList />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default Ordered